module.exports = __webpack_public_path__ + "static/img/4.54c6db1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/sp/4.png
// module id = u2NC
// module chunks = 0